import React, { useEffect } from 'react';
import { trackEvent } from '../../analytics/sml/analytics';
import { TypedMemo } from '../../common/types';
import { WishBoxModal } from './WishBoxModal';
import { closeWishBox, useWishBoxFrom } from './wishBoxStore';

/** Draws the one wish box of the app and sends `wish_box_opened`. */
const WishBoxHostComponent: React.FC = () => {
  const from = useWishBoxFrom();
  useEffect(() => {
    if (from !== null) {
      trackEvent('wish_box_opened', { from });
    }
  }, [from]);
  return from === null ? null : <WishBoxModal from={from} onClose={closeWishBox} />;
};

export const WishBoxHost = TypedMemo(WishBoxHostComponent);
